module.exports = __webpack_public_path__ + "static/media/b3_author_woah.265add22.mp3";